/**
 * Description: Shows the profile settings to update password and payment details
 * Author: Trushita
 * From scratch
 */
import React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import Header from "../components/Header";
import SideMenu from "../components/SideMenuProfile";
import secureCheckout from "../assets/images/secure_checkout.png";
import lockIcon from "../assets/images/password_icon.PNG";

// Profile settings Form 
const Settings = () => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <Header />
      </Grid>
      <Grid item xs={3}>
        <SideMenu />
      </Grid>
      <Grid item xs={9}>
        <Box bgcolor="#eceff1" mt={4} ml={1} mr={1}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box pl={2}>
                <Typography variant="h4" align="left" color="primary">
                  Settings
                </Typography>
              </Box>
            </Grid>
            
            <Grid item xs={6}>
              <Box pt={4} pl={1} pb={4}>
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <Typography variant="h6">Change Password</Typography>
                    <Divider />
                    <Box pt={2}>
                        <img width="25%" height="20%" src={lockIcon} alt="password lock"/>
                    </Box>
                    <Box pt={4} pl={5} pr={5}>
                      <TextField
                        type="password"
                        id="password"
                        label="Password"
                        value=""
                        variant="outlined"
                        fullWidth
                      />
                    </Box>
                    <Box pt={4} pl={5} pr={5}>
                      <TextField
                        type="password"
                        id="npassword"
                        label="New Password"
                        value=""
                        variant="outlined"
                        fullWidth
                      />
                    </Box>
                    <Box pt={4} pl={5} pr={5}>
                      <TextField
                        type="password"
                        id="cpassword"
                        label="Confirm Password"
                        value=""
                        variant="outlined"
                        fullWidth
                      />
                    </Box>
                    <Box pt={2}>
                       <Button variant="contained">Update Password</Button>
                    </Box>
                  </CardContent>
                </Card>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box pt={4} pb={4} pr={1}>
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <Typography variant="h6">Payment Information</Typography>
                    <Divider />
                    <Box pt={4} pl={5} pr={5}>
                      <TextField
                        id="card Name"
                        label="Name on Card"
                        value="John Brown"
                        variant="outlined"
                        fullWidth
                      />
                    </Box>
                    <Box pt={3} pl={5} pr={5}>
                      <TextField
                        id="cardNo"
                        label="Card Number"
                        value="2314 5432 5231"
                        variant="outlined"
                        fullWidth
                      />
                    </Box>
                    <Box pt={2} pl={5} pr={5} display="inline-flex">
                      <Box pr={2}>
                        <TextField
                          id="expiryDate"
                          label="Expiry Date"
                          value="10/22"
                          variant="outlined"
                          fullWidth
                        />
                      </Box>
                      <Box>
                        <TextField
                          id="cvv"
                          label="CVV"
                          value=""
                          variant="outlined"
                          fullWidth
                        />
                      </Box>
                    </Box>
                    <Box pt={2}>
                        <img width="80%" height="30%" src={secureCheckout} alt="secure checkout"/>
                    </Box>
                    <Box pt={1}>
                        <Button variant="contained"> Add New Card</Button>
                    </Box>
                  </CardContent>
                </Card>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Settings;
